import React, { useEffect } from 'react';
import { useAuthStore } from '../../store/useStore.js';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children, onUnauthenticated }) {
  const { isAuthenticated, user, isLoading, init } = useAuthStore();

  useEffect(() => {
    // Initialize auth state when component mounts
    init();
  }, [init]);

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    onUnauthenticated();
    return null;
  }

  return children;
}